import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';
import { JSX } from 'react';

import { ButtonProps } from './button.models';
import { useStyles } from './button.styles';

export const Button = ({
  children,
  to,
  variant,
  ariaLabel,
  onClick,
  startIcon,
  testId,
  isExternal,
  ...rest
}: ButtonProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      {to ? (
        <a
          {...rest}
          href={to}
          className={cx(classes.root, variant)}
          aria-label={ariaLabel && intl.formatMessage({ id: ariaLabel })}
          data-testid={testId}
          target={isExternal ? '_blank' : '_self'}
          rel="noopener noreferrer"
        >
          {children}
        </a>
      ) : (
        <button
          {...rest}
          aria-label={ariaLabel && intl.formatMessage({ id: ariaLabel })}
          className={cx(classes.root, variant)}
          onClick={onClick}
          data-testid={testId}
        >
          {children}
        </button>
      )}
    </>
  );
};
